<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uzMQD2/tc-custom/9781504080811.jpg?1718044032466" alt="This image is the cover for the book Witness on the Roof"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Witness on the Roof
      </h1>
      <p class="bookDescription body article font2">
        <p><b>When a poor girl witnesses a murder in Victorian London, the secret threatens her life as a wealthy lady in this classic from the Golden Age of mystery.</b></p><p> Whenever she needed to escape the menace of her scolding stepmother, little Polly Spencer snuck off to her favorite corner among the rooftops of London. But her innocent hiding spot gets her into serious trouble when she spies a crime scene through an open window. </p> Too afraid to go to the police, Polly is instead sent to live with her well-born mother’s family. Many years later, her life has changed considerably. As the wealthy and titled Lady Warchester, she inhabits a world utterly removed from the one she knew as a girl. But when she encounters the pale-faced killer once again, the past and its dangers are suddenly terrifyingly close.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Annie Haynes
      </h2>
      
      <p class="authorDescription body article"><P> Annie Haynes was born in Leicestershire, England, in 1864. With an &ldquo;intense interest in crime and criminal psychology,&rdquo; she once cycled to Ightham in Kent to visit the scene of Caroline Mary Luard&rsquo;s 1908 murder and pushed her way into the Hilldrop Crescent home of Dr. Crippen after the remains of his wife, Corrine, were found in the cellar in 1910. Haynes also attended the doctor&rsquo;s trial. Haynes&rsquo;s first novel, <I>The</I><I>Bungalow Mystery</I>, was published by Agatha Christie&rsquo;s publisher, The Bodley Head, in 1923. Haynes and Christie were the only two female authors to be published by the imprint. Eleven more novels followed, the last two being published posthumously. </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d5875b9c